import React, { useEffect, useState } from 'react';
import './ScrollTopButton.css';

const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    visible && (
      <button className="scroll-top-btn" onClick={scrollToTop}>
        ↑
      </button>
    )
  );
};

export default ScrollTopButton;
